import type { PipelineView } from '../../lib/client.ts';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select.tsx';

/** The pipeline a list or board shows, beside its toolbar (Projects, Deals, Jobs). */
export function PipelinePicker({
  pipelines,
  value,
  onChange,
}: {
  pipelines: readonly PipelineView[];
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-56" aria-label="Pipeline" data-testid="pipeline-picker">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {pipelines.map((p) => (
          <SelectItem key={p.id} value={p.id}>
            {p.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
